//REACT
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

//YUP
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

//MUI
import Box from "@mui/material/Box";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import Tooltip from "@mui/material/Tooltip";
import TextField from "@mui/material/TextField";
import LoadingButton from "@mui/lab/LoadingButton";
import SaveIcon from "@mui/icons-material/Save";
import { Typography } from "@mui/material";

//COMPONENTS
import { CustomScrollbar } from "../../customScrollbar/CustomScrollbar";

//DATEFIELD
import { DatePicker } from "@mui/lab";

const schema = yup.object().shape({
  collectionId: yup.string().required(),
  marketIsoCode: yup.string(),
  description: yup.string(),
  creationDate: yup.string(),
  startDate: yup.string(),
  endDate: yup.string(),
  flgActive: yup.boolean().required(),
  status: yup.string(),
  pointsThreshold: yup.number().positive().integer(),
});

const Form = ({ mode = "create", handleSave, currentProduct }) => {
  const isEdit = mode === "edit";
  const { id, dataCreation, ...collection } = currentProduct;

  const defaultValues = {
    ...{
      collectionId: "",
      marketIsoCode: "",
      description: "",
      creationDate: "",
      startDate: "",
      endDate: "",
      flgActive: false,
      status: "",
      pointsThreshold: 0,
    },
    ...collection,
  };

  const form = useForm({
    defaultValues,
    mode: "onBlur",
    resolver: yupResolver(schema),
  });

  const { register, handleSubmit, formState, reset } = form;
  const { errors, isValid, isDirty } = formState;

  useEffect(() => {
    reset(defaultValues);
  }, [currentProduct]);

  const onSubmit = (data) => {
    handleSave(data);
  };

  return (
    <CustomScrollbar>
      <Box
        id="collectionsForm"
        component="form"
        onSubmit={handleSubmit(onSubmit)}
        noValidate
        maxWidth="95%"
        maxHeight="35vw"
      >
        <Grid2 container spacing={3}>
          <Grid2 xs={12}>
            <Typography variant="h3" color="primary">
              Collection {isEdit ? "details" : "creation"}
            </Typography>
          </Grid2>
          <Grid2 xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Collection ID"
              color="primary"
              fullWidth
              required
              error={!!errors.collectionId}
              helperText={errors.collectionId?.message}
              {...register("collectionId")}
            />
          </Grid2>

          <Grid2 xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Market ISO code"
              color="primary"
              fullWidth
              required
              error={!!errors.marketIsoCode}
              helperText={errors.marketIsoCode?.message}
              {...register("marketIsoCode")}
            />
          </Grid2>

          <Grid2 xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Description"
              color="primary"
              fullWidth
              required
              error={!!errors.description}
              helperText={errors.description?.message}
              {...register("description")}
            />
          </Grid2>

          <Grid2 item xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Creation date"
              type="date"
              color="primary"
              fullWidth
              required
              error={!!errors.creationDate}
              helperText={errors.creationDate?.message}
              {...register("creationDate")}
            />
            <DatePicker />
          </Grid2>

          <Grid2 item xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Start date"
              type="date"
              color="primary"
              fullWidth
              required
              error={!!errors.startDate}
              helperText={errors.startDate?.message}
              {...register("startDate")}
            />
            <DatePicker />
          </Grid2>

          <Grid2 item xs={6}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="End date"
              type="date"
              color="primary"
              fullWidth
              required
              error={!!errors.endDate}
              helperText={errors.endDate?.message}
              {...register("endDate")}
            />
            <DatePicker />
          </Grid2>

          <Grid2 xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Flag Active"
              color="primary"
              fullWidth
              required
              error={!!errors.flgActive}
              helperText={errors.flgActive?.message}
              {...register("flgActive")}
            />
          </Grid2>

          <Grid2 xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Status"
              color="primary"
              fullWidth
              required
              error={!!errors.status}
              helperText={errors.status?.message}
              {...register("status")}
            />
          </Grid2>

          <Grid2 xs={12}>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Points Threshold"
              color="primary"
              fullWidth
              required
              error={!!errors.pointsThreshold}
              helperText={errors.pointsThreshold?.message}
              {...register("pointsThreshold")}
            />
          </Grid2>

          <Grid2 xs={12}>
            <Tooltip arrow title={(false && "a") || ""}>
              <LoadingButton
                type="submit"
                loading={false}
                loadingPosition="start"
                startIcon={<SaveIcon />}
                variant="contained"
                sx={{
                  boxShadow: "none",
                  padding: "5px 12px 4px 12px",
                }}
                color="primary"
                onClick={() => {}}
                disabled={isDirty && !isValid}
              >
                Save
              </LoadingButton>
            </Tooltip>
          </Grid2>
        </Grid2>
      </Box>
    </CustomScrollbar>
  );
};

export default Form;
